import { createFileRoute, redirect } from '@tanstack/react-router';

import { JobRunsPage } from '@/components/features/background-jobs/JobRunsPage';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';
import { userHasRole } from '@/utils/roles';

export const Route = createFileRoute('/_protected/jobs_/$jobName')({
  beforeLoad: ({ context }) => {
    if (!userHasRole(context.user, 'admin')) {
      throw redirect({ to: '/', replace: true });
    }
  },
  component: JobRunsRoute,
});

function JobRunsRoute() {
  const { jobName } = Route.useParams();
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <JobRunsPage jobName={jobName} />
    </ErrorBoundary>
  );
}
